import { render } from "./loans.vue?vue&type=template&id=2974b449&scoped=true"
import script from "./loans.vue?vue&type=script&lang=js"
export * from "./loans.vue?vue&type=script&lang=js"

import "./loans.vue?vue&type=style&index=0&id=2974b449&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2974b449"]])

export default __exports__